module.exports = __webpack_public_path__ + "img/chinesecompany153.56b2c394.png";